import { render, staticRenderFns } from "./TagAttributeDetail.vue?vue&type=template&id=05331e8a&scoped=true"
import script from "./TagAttributeDetail.vue?vue&type=script&lang=js"
export * from "./TagAttributeDetail.vue?vue&type=script&lang=js"
import style0 from "./TagAttributeDetail.vue?vue&type=style&index=0&id=05331e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05331e8a",
  null
  
)

export default component.exports